export default "__VITE_ASSET__5cabed62__"